import styled from 'styled-components';
import { FlexColCenter, FlexColStart } from '@styles/global-styles';

export const DialogHotspotArticleWrapper = styled.div`
  background: var(--color-popup-bg);
  color: var(--color-popup-text);
  height: max-content;
  max-height: 95vh;
  overflow: auto;
  width: 100%;
  padding: 0;
  border-radius: 12px;
  ${FlexColStart};
  .header {
    ${FlexColCenter};
    position: relative;
    border-bottom: 1px solid rgb(255 255 255 / 0.2);
    padding: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .thumb {
      width: max-content;
      max-width: 100%;
      height: auto;
    }
    &:after {
      content: '';
      width: 64px;
      height: 2px;
      background: var(--color-popup-text);
      display: block;
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
  .title {
    font-weight: 600;
    width: 100%;
    position: relative;
    font-size: 1rem;
    text-transform: uppercase;
    text-align: center;
    padding: 1.5rem 3rem;
    background: rgba(0, 0, 0, 0.1);
  }
  .body {
    width: 100%;
    height: 100%;
    padding: 1.5rem 3rem;
    margin: 0 auto;
    height: auto;
    .content {
      width: 100%;
      /* background: var(--color-popup-bg);
      color: var(--color-popup-text); */
    }
  }
  @media (max-width: 575px) {
    .body {
      padding: 1.5rem 1rem;
    }
  }
  &.size-compact {
    max-width: 560px;
    max-height: 480px;
    margin: auto;
  }
  &.layout-leftToRight {
    flex-flow: row;
    align-items: flex-start;
    .header {
      border: none;
      padding: 0 1rem;
      margin-top: 1.5rem;
      &:after {
        display: none;
      }
      .thumb {
        border: 1px solid rgba(255, 255, 255, 0.2);
        padding: 0.5rem;
        margin: 0.5rem;
      }
    }
    .body {
      padding: 1.5rem 2rem;
    }
    .title {
      padding: 0;
      text-align: left;
      font-size: 1.2rem;
      margin-bottom: 1rem;
      &:after {
        // content: '';
        // width: 42px;
        // height: 2px;
        // background: #fff;
        // margin: 1rem 0 2rem;
        // display: block;
      }
    }
    .thumb {
      height: auto;
      width: 100%;
      max-height: 380px;
      object-fit: contain;
    }
    @media (max-width: 575px) {
      flex-flow: column;
    }
  }
`;
